import { render, staticRenderFns } from "./purchaseHall.vue?vue&type=template&id=3d61f41c&scoped=true"
import script from "./purchaseHall.vue?vue&type=script&lang=js"
export * from "./purchaseHall.vue?vue&type=script&lang=js"
import style0 from "./purchaseHall.vue?vue&type=style&index=0&id=3d61f41c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d61f41c",
  null
  
)

export default component.exports